var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgK8SDaemonSet = function SvgK8SDaemonSet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 2h10a1 1 0 0 1 1 1v4h-1V3H3v10h4v1H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.5 15a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m2.45-3A2.5 2.5 0 0 1 12 13.95V12zm0-1A2.5 2.5 0 0 0 12 9.05V11zM11 11V9.05c-.98.199-1.751.97-1.95 1.95zm-1.95 1c.199.98.97 1.751 1.95 1.95V12z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.875 7.302a2 2 0 1 0-2.573 2.573 4.5 4.5 0 0 0-.255.97 3.001 3.001 0 1 1 3.798-3.798 4.5 4.5 0 0 0-.97.255"
  })));
};
export default SvgK8SDaemonSet;